import { NgModule } from "@angular/core";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

import { AngularFireModule } from "@angular/fire";
import { AngularFireAuthModule } from "@angular/fire/auth";

import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { ToastrModule } from "ngx-toastr";
import { AgmCoreModule } from "@agm/core";
import { HttpClientModule, HttpClient } from "@angular/common/http";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { StoreModule } from "@ngrx/store";
import { DragulaService } from "ng2-dragula";
import { NgxSpinnerModule } from 'ngx-spinner';

import {
  PerfectScrollbarModule,
  PERFECT_SCROLLBAR_CONFIG,
  PerfectScrollbarConfigInterface
} from 'ngx-perfect-scrollbar';

import { AppRoutingModule } from "./app-routing.module";
import { SharedModule } from "./shared/shared.module";
import * as fromApp from './store/app.reducer';
import { AppComponent } from "./app.component";
import { ContentLayoutComponent } from "./layouts/content/content-layout.component";
import { FullLayoutComponent } from "./layouts/full/full-layout.component";



import { WINDOW_PROVIDERS } from './shared/services/window.service';

var firebaseConfig = {
  apiKey: "YOUR_API_KEY", //YOUR_API_KEY
  authDomain: "YOUR_AUTH_DOMAIN", //YOUR_AUTH_DOMAIN
  databaseURL: "YOUR_DATABASE_URL", //YOUR_DATABASE_URL
  projectId: "YOUR_PROJECT_ID", //YOUR_PROJECT_ID
  storageBucket: "YOUR_STORAGE_BUCKET", //YOUR_STORAGE_BUCKET
  messagingSenderId: "YOUR_MESSAGING_SENDER_ID", //YOUR_MESSAGING_SENDER_ID
  appId: "YOUR_APP_ID", //YOUR_APP_ID
  measurementId: "YOUR_MEASUREMENT_ID" //YOUR_MEASUREMENT_ID
};

//CSP SECTION
import { AuthServices } from '@services';
import { AppServices, UserServices, DictionaryServices, AlertServices } from '@services';
import { appHttpClient } from '@framework'
import { HttpModule } from '@angular/http';
import { AuthModule } from './+auth/auth.module';
import { environment as env } from 'environments/environment';
import { GuardModule } from '@guards';
import { SocketConnection } from "@services/app/socket-io";
import { CallerServices } from "@services/app/caller.services";
import { Router } from "@angular/router";

//RL CUSTOM SECTION
// import { UserServices_Accidentcare } from '@services';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
  wheelPropagation: false
};

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, env.app_apiURL + '/assets/i18n/', '.json');
}

export function SocketFactory() {
  const _ePOS = (location.origin.indexOf('epos.app.cspcom.com') > -1 ? true : false) || env.DevelopProject === 'ePOS';
  if (_ePOS) {
     return new SocketConnection('ePOS@Parco#22833300#');
  } else {
    return new SocketConnection('Undefined');
  }
}

// export function AuthenticationFactory(_http: appHttpClient, _router: Router) {
// const _isRescueline = (location.origin.indexOf('accidentcare.rescueline.com.cy') > -1 ? true : false) || env.DevelopProject === 'RescueLine';
//   if (_isRescueline) {
//      return new AuthServices_Accidentcare(_http, _router);
//   } else {
//     return new AuthServices(_http, _router);
//   }
// }

@NgModule({
  declarations: [AppComponent, FullLayoutComponent, ContentLayoutComponent],
  imports: [
    AuthModule,
    HttpModule,
    BrowserAnimationsModule,
    StoreModule.forRoot(fromApp.appReducer),
    GuardModule.forRoot(),
    AppRoutingModule,
    SharedModule,
    HttpClientModule,
    AngularFireModule.initializeApp(firebaseConfig),
    AngularFireAuthModule,
    ToastrModule.forRoot(),
    NgbModule,
    NgxSpinnerModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    }),
    AgmCoreModule.forRoot({
      apiKey: "YOUR_GOOGLE_MAP_API_KEY"
    }),
    PerfectScrollbarModule,
  ],
  providers: [
    DragulaService,
    { provide: PERFECT_SCROLLBAR_CONFIG, useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG },
    { provide: PERFECT_SCROLLBAR_CONFIG, useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG },
    WINDOW_PROVIDERS,
    { provide: 'appHttpClient', useClass: appHttpClient },
    //{ provide: 'AuthServices', useFactory: AuthenticationFactory, deps: ['appHttpClient', Router] },
    { provide: 'AuthServices', useClass: AuthServices },
    { provide: 'UserServices', useClass: UserServices },
    { provide: 'AppServices', useClass: AppServices },
    { provide: 'DictionaryServices', useClass: DictionaryServices },
    { provide: 'AlertServices', useClass: AlertServices },
    { provide: 'CallerServices', useClass: CallerServices },  
    { provide: 'SocketConnection', useFactory: SocketFactory }, 
    //{ provide: 'SocketConnection', useClass: SocketConnection },   
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
